import { EditOutlined, DeleteOutlined, DownOutlined, PlusOutlined } from '@ant-design/icons';
import { Dropdown, Menu, Button, Space } from 'antd';
import { useTranslation } from 'react-i18next';
import { type BankModuleSpecsFragment } from '../../../../api/fragments/BankModuleSpecs';
import { type PermissionValues } from '../../../../utilities/hasPermissions';
import useDeleteModule from '../useDeleteModule';
import { useUpdateBankModuleDrawer } from './BankModuleUpdateDrawer';
import { type OpenRemoteFPSettingDrawer } from './RemoteFPSettingDrawer';

export type BankModuleActionsProps = {
    module: BankModuleSpecsFragment;
    openRemoteFPSettingDrawer: OpenRemoteFPSettingDrawer;
    permissions: Pick<PermissionValues, 'hasDeletePermission' | 'hasUpdatePermission'>;
};

const BankModuleActions = ({ module, openRemoteFPSettingDrawer, permissions }: BankModuleActionsProps) => {
    const { t } = useTranslation(['bankModuleDetails', 'moduleDetails']);
    const deleteModule = useDeleteModule(module.id);

    const updateBankModuleDrawer = useUpdateBankModuleDrawer(module);
    const { hasUpdatePermission, hasDeletePermission } = permissions;

    const items = [
        hasUpdatePermission && {
            label: t('bankModuleDetails:mainActionButtons.updateSpecs'),
            key: 'updateSpecs',
            icon: <EditOutlined />,
            onClick: updateBankModuleDrawer.open,
        },
        hasUpdatePermission && {
            label: t('bankModuleDetails:mainActionButtons.addRemoteFPSetting'),
            key: 'addRemoteFPSetting',
            icon: <PlusOutlined />,
            onClick: () => {
                openRemoteFPSettingDrawer();
            },
        },
        hasDeletePermission && {
            label: t('bankModuleDetails:mainActionButtons.delete'),
            key: 'delete',
            icon: <DeleteOutlined />,
            onClick: deleteModule,
            danger: true,
        },
    ].filter(Boolean);

    if (!items.length) {
        return null;
    }

    return (
        <>
            <Dropdown overlay={<Menu items={items} />}>
                <Button type="primary">
                    <Space>
                        <span>{t('bankModuleDetails:mainActionButtons.actions')}</span>
                        <DownOutlined />
                    </Space>
                </Button>
            </Dropdown>
            {updateBankModuleDrawer.render()}
        </>
    );
};

export default BankModuleActions;
